import { SxProps, useMediaQuery } from "@mui/material";
import { BoxTypeMap } from "@mui/system";
import Box from "./BoxExtended";
import { DefaultComponentProps } from "@mui/material/OverridableComponent";
import { useEffect } from "react";

type MediaQueryBoxProps = {
  showIf: string;
  onBreak?: () => void;
  sx: SxProps;
  children: any;
};

/**
 * ## DEPRECATED
 *
 * Do not reuse or modify, replace references with MUI's breakpoint system.
 */
function MediaQueryBox(props: MediaQueryBoxProps) {
  const isResized = useMediaQuery(props.showIf);
  useEffect(() => {
    if (isResized && props.onBreak) {
      props.onBreak();
    }
  }, [isResized, props.onBreak]);

  return (
    <Box
      sx={{
        display: "none",
        [props.showIf]: props.sx ? { ...props.sx } : { ...{ display: "block" } },
      }}
    >
      {props.children}
    </Box>
  );
}

export default MediaQueryBox;
